<template>
  <div class="lose-reason-dialog">
    <el-dialog custom-class="with-title large" :title="title" :visible.sync="visible" :before-close="beforeClose">
      <div v-loading="loading">
        <div class="mb-x1" layout layout-align="space-between-center">
          <lose-reason-table
            :loseReasons="loseReasons"
            :sortBy="options.sortBy"
            @sorting="onChangeSortBy"
          ></lose-reason-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import Util from '@/client/core/util'
import LoseReasonTable from '@/client/features/twitter_instantwin_message_history/lose_reason_table'
import { useSystemStore } from '@/client/store/useSystemStore'
import { useTwitterInstantwinLoseReasonStore } from '@/client/store/useTwitterInstantwinLoseReasonStore'

export default defineComponent({
  data() {
    return {
      title: '落選理由ごとの件数',
      visible: false
    }
  },
  components: {
    LoseReasonTable
  },
  computed: {
    ...mapState(useSystemStore, {
      groupId: state => state.currentGroup?.id
    }),
    ...mapState(useTwitterInstantwinLoseReasonStore, {
      params: state => state.params,
      options: state => {
        return {
          sortBy: state.params.sortBy
        }
      },
      loading: state => state.loading,
      loseReasons: state => state.loseReasons
    })
  },
  watch: {
    params() {
      this.fetchLoseReasons()
    }
  },
  methods: {
    ...mapActions(useTwitterInstantwinLoseReasonStore, ['reset', 'fetchLoseReasons', 'setParams']),
    /**
     * 変更イベント
     * @param {any} payload ページ
     */
    onChangePaging(payload: any) {
      this.setParams(payload)
      Util.scrollToTop()
    },

    /**
     * ソートを変更イベント
     * @param {any} payload ソート
     */
    onChangeSortBy(payload: any) {
      if (this.params.sortBy === payload.sortBy) {
        return
      }
      this.setParams(payload)
    },

    /**
     * ダイアログを開く
     */
    open(campaignId: number) {
      this.setParams({ campaignId })
      this.visible = true
    },

    /**
     * ダイアログ閉じるイベント
     */
    beforeClose(done) {
      this.reset()
      done()
    }
  }
})
</script>
